import axios from 'axios';
import router from '../routes';
import { getEnv } from '../helpers';

var baseURL = "";
var api = "";
var loading = "";

api = axios.create({ 
    responseType: 'json', 
    formAutenticacao: 'modal' 
});

getEnv().then(async (env) => { 
    baseURL = await env.VUE_APP_BACKEND_URL;   
    api.defaults.baseURL = baseURL;
});

loading = {
    list: [],
    start(item = 0) {
        this.list.push(item);
        if(this.list.length === 1)
            router.app.carregando = true;
    },
    finish(item = 0) {
        let index = this.list.indexOf(item);
        if(index !== -1)
            this.list.splice(index, 1);
        if(this.list.length === 0)
            router.app.carregando = false;
    }
}

api.interceptors.request.use((config) => {
    config.request_id = Math.random();
    loading.start(config.request_id);
    return config;
});

api.interceptors.response.use(
    (response) => {
        loading.finish(response.config.request_id);
        return response;
    },
    (error) => {
        loading.finish(error.response.config.request_id);
        let status = Number.parseInt(error.response.status);
        let objVue = router.app;

        // tratando mensagem de erros quando esperamos um blob
        if (error.request.responseType === 'blob' &&
            error.response.data instanceof Blob &&
            error.response.data.type &&
            error.response.data.type.toLowerCase().indexOf('json') != -1)
        {
            return new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.onload = () => {
                error.response.data = JSON.parse(reader.result);
                resolve(Promise.reject(error));
            };

            reader.onerror = () => {
                reject(error);
            };

            reader.readAsText(error.response.data);
            });
        }
        
        //erros de servidor
        if (status > 499) {
            objVue.$helper.printMsg(objVue, error, {
                dialog: {
                    variant: "danger",
                    title: `Erro de servidor - ${status}`
                }
            });
        }

        return Promise.reject(error);
    }
);

export {
    api,
    loading,
};

export default api;